import { z } from 'zod';

export const Z_Session = z.object({
  id: z.number().optional(),
  user_id: z.number().optional(),
  identity: z.number().nullable(),
  is_logged_in: z.boolean(),
  has_signed_up: z.boolean(),
  email: z
    .string()
    .email()
    .or(z.enum(['']))
    .optional(),
  first_name: z.string().optional(),
  last_name: z.string().optional(),
  username: z.string().optional(),
  last_login: z.string().optional(),
  timezone: z.string().optional().nullable(),
  photo_url: z
    .string()
    .url()
    .or(z.enum(['']))
    .optional()
    .nullable(),
  signup: z.string().optional(),
  since_signup: z.string().optional(),
  has_activated: z.boolean().optional(),
  is_staff: z.boolean().optional(),
  is_developer: z.boolean().optional(),
  is_expert: z.boolean().optional(),
  is_high_value: z.boolean().optional(),
  is_temporary: z.boolean().optional(),
  banner_message: z.string().optional(),
  organizations: z.array(z.number().nullable()).optional(),
  primary_organization: z.number().optional().nullable(),
  has_active_zaps: z.boolean().optional(),
  current_account_id: z.number().nullable(),
  roles: z
    .array(
      z.object({
        account_id: z.number(),
        role: z.enum(['owner', 'member', 'admin', 'super_admin']),
      }),
    )
    .optional(),
});

export type Session = z.infer<typeof Z_Session>;
